import MemberPanelAuthSlice from "../Redux/Slice/MemberPanelAuthSlice";
import { Store } from "../Redux/Store";

class MemberPanelAuth {
  // set session
  static setSession({ token, member_detail }) {
    try {
      localStorage.setItem("member_auth_token", token);
      localStorage.setItem("member_detail", JSON.stringify(member_detail));
      Store.dispatch(
        MemberPanelAuthSlice.actions.refreshMemberPanelAuthReducer()
      );
    } catch (error) {
      MemberPanelAuth.logout();
    }
  }

  // logout
  static logout() {
    localStorage.removeItem("member_auth_token");
    localStorage.removeItem("member_detail");
    Store.dispatch(
      MemberPanelAuthSlice.actions.refreshMemberPanelAuthReducer()
    );
  }

  // get session data
  static getSessionData() {
    try {
      return {
        token: localStorage.getItem("member_auth_token"),
        member_detail: JSON.parse(localStorage.getItem("member_detail")),
      };
    } catch (error) {
      MemberPanelAuth.logout();
    }
  }
}

export default MemberPanelAuth;
